import { Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { AlertComponent, ButtonComponent, CheckboxComponent, MbsPopupType, ModalComponent, ModalFooterDirective } from 'mbs-ui-kit';

import { I18NextPipe } from 'angular-i18next';

import { ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'mbs-private-storage-modal',
  templateUrl: './private-storage.component.html',
  imports: [AlertComponent, ButtonComponent, CheckboxComponent, I18NextPipe, ModalComponent, ReactiveFormsModule, ModalFooterDirective]
})
export class PrivateStorageModalComponent {
  public errorText: string;
  public confirmation = new FormControl(false);

  public readonly mbsPopupType = MbsPopupType;
}
